// extracted by mini-css-extract-plugin
module.exports = {"accordionContainer":"CategoryLinkAccordion_accordionContainer__vbgyI","categoryLink":"CategoryLinkAccordion_categoryLink__yJvko"};